import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { auth } = Dictionary

const authentication = {
  login: async (data: {}, headers: any) => {
    return axios.post(BASE_URL + auth.login(), data, { headers: headers })
  },
  logout: async (headers: any) => {
    return axios.post(BASE_URL + auth.logout(), { headers: headers })
  },
  changePassword: async (payload: {}) => {
    return axios.put(BASE_URL + auth.changePassword(), payload)
  },
}
export default authentication
